
<div class="flex-col w-full p-8">
    <div class=" font-semibold text-black text-4xl mb-7">
        Terms & Conditions
    </div>

    <ng-container *ngIf="!loading">
      <div *ngFor="let category of termsAndConditionsCategories; let i = index" class="w-full">
        <!-- Category Heading -->
        <div class="w-full flex flex-row justify-between items-center cursor-pointer mt-2" (click)="toggleCategory(i)">
          <h2 class="text-2xl font-bold text-primary">{{ category.termsCategoryName }}</h2>
          <mat-icon *ngIf="!catOpenMap[i]" class="icon-size-4 mr-6" svgIcon="heroicons_solid:chevron-right"></mat-icon>
          <mat-icon *ngIf="catOpenMap[i]" class="icon-size-4 mr-6" svgIcon="heroicons_solid:chevron-down"></mat-icon>
        </div>
        <hr class="mt-2 mb-3" />
      
        <!-- Category Content with Animation -->
        <div [@expandCollapse]="catOpenMap[i] ? 'expanded' : 'collapsed'" class="overflow-hidden transition-all duration-300 fuse-card rounded-lg shadow-md px-3 pt-2">
          <div *ngFor="let tc of category.terms_and_conditions; let j = index; let last = last" class="my-4">
            <div
              class="cursor-pointer transition-all duration-300"
              (click)="toggleTc(i, j)"
            >
            <!-- TC Header -->
              <div
                class="flex justify-between items-center pb-1"
                [ngClass]="{ 'border-b border-gray-300': !last }"
              >
                <h3 class="text-base font-extrabold text-black">
                  {{ tc.Heading }}
                </h3>
                <mat-icon
                  class="text-primary ml-4"
                  [svgIcon]="tcOpenMap[i]?.[j] ? 'heroicons_solid:minus-circle' : 'heroicons_solid:plus-circle'"
                ></mat-icon>
              </div>
      
              <!-- TC Content -->
              <div
                class="mt-1 text-sm text-gray-700 overflow-hidden transition-all duration-300"
                [@expandCollapse]="tcOpenMap[i]?.[j] ? 'expanded' : 'collapsed'"
                [ngClass]="{ 'border-b border-gray-200': !last }"
              >
                <div [innerHTML]="tc.Information | innerHTMLPipe"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    
    
    
</div>